import { useCallback } from "react"

import { adminSkuSavingData, isReloadAdminSkuData } from "../@signals"


export default function useAdminSkuSavingData() {

    const getSavingData = useCallback(skuID => {
        return adminSkuSavingData.value.find(item => item.skuID === skuID) || {}
    }, [])

    const updateSavingData = useCallback((skuID, newData={}, reload=false) => {
        let foundSku = false

        adminSkuSavingData.value = [...adminSkuSavingData.value.map(dataRow => {
            if (dataRow.skuID !== skuID)
                return dataRow
            foundSku = true
            return {
                ...dataRow,
                ...newData
            }
        })]

        if (!foundSku)
            adminSkuSavingData.value = [...adminSkuSavingData.value, newData]
        if (reload)
            isReloadAdminSkuData.value = true
    }, [])

    return {
        getSavingData,
        updateSavingData
    }
}